import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

// Line-by-line masked reveal for headings. `lines` is an array of strings.
export const MaskLines = ({ lines, className = "", delay = 0, stagger = 0.09 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="line-mask">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1.05, ease, delay: delay + i * stagger }}
        >
          {line}{i < lines.length - 1 ? " " : ""}
        </motion.span>
      </span>
    ))}
  </span>
);

export const MaskLinesInView = ({ lines, className = "", stagger = 0.09 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="line-mask">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          whileInView={{ y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 1, ease, delay: i * stagger }}
        >
          {line}{i < lines.length - 1 ? " " : ""}
        </motion.span>
      </span>
    ))}
  </span>
);
